import React, { useState } from "react";
import "./RepostModal.css";

const RepostModal = ({
  isOpen,
  onClose,
  onRepost,
  originalPost,
  loading = false,
}) => {
  const [repostText, setRepostText] = useState("");

  if (!isOpen) return null;

  const handleRepost = () => {
    onRepost(repostText.trim() || null);
    setRepostText("");
  };

  const handleClose = () => {
    setRepostText("");
    onClose();
  };

  return (
    <div className="repost-modal-overlay" onClick={handleClose}>
      <div className="repost-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="repost-modal-header">
          <button className="repost-close-btn" onClick={handleClose}>
            <svg
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <h2>Repost</h2>
          <button
            className="repost-submit-btn"
            onClick={handleRepost}
            disabled={loading}
          >
            {loading ? "Posting..." : "Repost"}
          </button>
        </div>

        {/* Body */}
        <div className="repost-modal-body">
          {/* Optional text input */}
          <textarea
            className="repost-text-input"
            placeholder="Add your thoughts (optional)..."
            value={repostText}
            onChange={(e) => setRepostText(e.target.value)}
            rows={3}
            maxLength={500}
          />

          {/* Character count */}
          {repostText.length > 0 && (
            <div className="repost-char-count">{repostText.length}/500</div>
          )}

          {/* Original post preview */}
          {originalPost && (
            <div className="original-post-preview">
              <div className="preview-header">
                <img
                  src={
                    originalPost.author?.profilePhotoUrl ||
                    "/default-avatar.png"
                  }
                  alt={originalPost.author?.name}
                  className="preview-avatar"
                />
                <div className="preview-author-info">
                  <span className="preview-author-name">
                    {originalPost.author?.name}
                  </span>
                  <span className="preview-author-title">
                    {originalPost.author?.title ||
                      originalPost.author?.headline}
                  </span>
                </div>
              </div>
              <div className="preview-content">
                {originalPost.content?.substring(0, 150)}
                {originalPost.content?.length > 150 && "..."}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RepostModal;
